<template>
  <div class="config_main_manage_background">
    <!-- // 代号 20231207-1  组功能实现 -->
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item"
                      @click.native="configGoPreviousPageHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/zuofanhui.png"
               alt />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">选择组类型</div>
        </top-nav-item>
        <top-nav-item class="right_item"
                      @click.native="configReturnContronBtnHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/shebei_home.png"
               alt />
        </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2">所有的控制类型</span>
        </config-title-hang>

        <!-- 服务器返回的所有类型列表 -->
        <config-hang v-for="(objectValue, index) in serveControlTypeListData"
                     :key="index"
                     @click.native="selectSceneBtnHandle(objectValue)"
                     :selectState="OneInfo.productCode == objectValue.value">
          <span slot="config_hang_ele2">{{ objectValue.label }}</span>
          <img slot="config_hang_weixuan"
               src="~assets/img/config/weixuan.png"
               alt />
          <img slot="config_hang_xuanzhong"
               src="~assets/img/config/xuanzhong.png"
               alt />
        </config-hang>

        <div class="public_config_que_ren_btn"
             @click="saveReturnBtnHandle">
          保存并返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import { mediumslateblue } from 'color-name'

export default {
  data () {
    return {
      serveControlTypeListData: {
        ///服务器返回的控制类型数据
      },
      OneInfo: {
        // 必须有以下两个空字段 否则会导致选择异常
        productCode: '',
        productName: '',

      }
    }
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    configGoPreviousPageHandle () {
      ////返回上一级的按钮  返回上一级  不保存当前勾选项
      this.$router.go(-1);
    },
    configReturnContronBtnHandle () {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath);
    },
    selectSceneBtnHandle (objectValue) {
      console.log("111111");
      this.OneInfo.productCode = objectValue.value;
      this.OneInfo.productName = objectValue.label;
    },
    saveReturnBtnHandle () {
      console.log("111111" + this.OneInfo.productName);
      ///保存并返回按钮点击了
      if (this.OneInfo.productCode === '') {
        this.$toast('请至少选择一个类型！')
        return
      }

      ////提交页面用户设置的部分场景信息的区域信息地址 到仓库（注意提交的是地址，但实际不是地址，最后做了一下深层克隆）
      console.log(typeof this.$route.query.type);
      if (this.$route.query.type == 1) {
      } else if (this.$route.query.type == 2) {
      } else if (this.$route.query.type == 3) {
        ///3代表是组页面进来 选择区域的  出去的时候需要判断提交的地址
        console.log(this.OneInfo);
        this.$store.dispatch("asyUpdataOneGroupinfo", this.OneInfo);
      }
      this.$router.go(-1)
    }
  },
  created () {
    console.log('created阶段')

    ///获取设备按钮列表(触发类型)接口，获取数据
    this.$request({
      method: 'post',
      url: '/userGroup/findGroupProductCodeList',
      data: {
        token: this.$store.state.token,
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveControlTypeListData = res.data.data ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })


    //需要把进来时的仓库的状态更新进来，根据页面进来的类型进行判断
    if (this.$route.query.type === 1) {

    } else if (this.$route.query.type === 2) {

    } else if (this.$route.query.type === 3) {
      ///3代表是组页面进来 选择区域的  进来的时候需要判断拉取数据
      this.OneInfo.productCode = this.$store.state.configinfo.OneGroupinfo.productCode;
      this.OneInfo.productName = this.$store.state.configinfo.OneGroupinfo.productName;
    }

  }
}
</script>

<style></style>
